export const Actions = {
  LIST_REMINDER_PROFILES: "LIST_REMINDER_PROFILES",
  LIST_REMINDER_PROFILES_SUCCEEDED: "LIST_REMINDER_PROFILES_SUCCEEDED",
  LIST_RENEWALS: "LIST_RENEWALS",
  LIST_RENEWALS_SUCCEEDED: "LIST_RENEWALS_SUCCEEDED",
  LIST_ASSIGNEES: "LIST_ASSIGNEES",
  LIST_ASSIGNEES_SUCCEEDED: "LIST_ASSIGNEES_SUCCEEDED",
  LIST_PRODUCER_CODES: "RENEWAL/LIST_PRODUCER_CODES",
  LIST_PRODUCER_CODES_SUCCEEDED: "RENEWAL/LIST_PRODUCER_CODES_SUCCEEDED",
  SET_SELECTED_ROWS: "SET_SELECTED_ROWS_MANAGE",
  CLEAR_SELECTED_ROWS: "CLEAR_SELECTED_ROWS_MANAGE",
  READ_RENEWAL_DETAILS: "READ_RENEWAL_DETAILS",
  READ_RENEWAL_DETAILS_SUCCEEDED: "READ_RENEWAL_DETAILS_SUCCEEDED",
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  CLEAR_REMINDER_PROFILES: "CLEAR_REMINDER_PROFILES",
  SET_SEARCH_VALUES: "RENEWAL/SET_SEARCH_VALUES",
  CLEAR_RENEWAL_LIST: "CLEAR_RENEWAL_LIST",
  CLEAR_SELECTED_RENEWAL: "CLEAR_SELECTED_RENEWAL",
  CLEAR_OPERATION_RESULT: "CLEAR_OPERATION_RESULT",
  BULK_ASSIGN_RENEWALS: "BULK_ASSIGN_RENEWALS",
  BULK_ASSIGN_RENEWALS_SUCCEEDED: "BULK_ASSIGN_RENEWALS_SUCCEEDED",
  BULK_UPDATE_PRODUCER_CODE: "BULK_UPDATE_PRODUCER_CODE",
  BULK_UPDATE_PRODUCER_CODE_SUCCEEDED: "BULK_UPDATE_PRODUCER_CODE_SUCCEEDED",
  CLEAR_BULK_ASSIGN_DATA: "CLEAR_BULK_ASSIGN_DATA",
  CLEAR_BULK_PRODUCER_UPDATE_DATA: "CLEAR_BULK_PRODUCER_UPDATE_DATA",
  CLEAR_BULK_PRODUCER_TARGETS: "CLEAR_BULK_PRODUCER_TARGETS",
  READ_REMINDER_PREFERENCES: "READ_REMINDER_PREFERENCES",
  READ_REMINDER_PREFERENCES_SUCCEEDED: "READ_REMINDER_PREFERENCES_SUCCEEDED",
  UPDATE_REMINDER_PREFERENCES: "UPDATE_REMINDER_PREFERENCES",
  UPDATE_REMINDER_PREFERENCES_SUCCEEDED: "UPDATE_REMINDER_PREFERENCES_SUCCEEDED",
  LIST_REMINDER_PREFERENCE_CHANGE_REASONS: "LIST_REMINDER_PREFERENCE_CHANGE_REASONS",
  LIST_REMINDER_PREFERENCE_CHANGE_REASONS_SUCCEEDED: "LIST_REMINDER_PREFERENCE_CHANGE_REASONS_SUCCEEDED",
  LIST_REMINDER_PREFERENCE_STATUSES: "LIST_REMINDER_PREFERENCE_STATUSES",
  LIST_REMINDER_PREFERENCE_STATUSES_SUCCEEDED: "LIST_REMINDER_PREFERENCE_STATUSES_SUCCEEDED",
  CLEAR_REMINDER_PREFERENCES_OPERATION_RESULT: "CLEAR_REMINDER_PREFERENCES_OPERATION_RESULT",
};
